import React, { useState } from 'react';
import cn from 'classnames';

import { Collapse } from '@crehana/ui';
import { ArrowIosDown } from '@crehana/icons/dist/outline';

import ButtonAnimation from '../ButtonAnimation';

interface HamburgerMenuProps {
  label: string | JSX.Element;
  isDefaultOpen?: boolean;
  classNameTitle?: string;
  onChange?: (isOpen: boolean) => void;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  label,
  isDefaultOpen,
  classNameTitle,
  children,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!isDefaultOpen);

  const toggle = () => setIsOpen(!isOpen);

  React.useEffect(() => {
    onChange?.(isOpen);
  }, [isOpen]);

  return (
    <div className="HamburgerMenu">
      <button
        className={cn(
          `flex items-center justify-between w-full transition-all duration-500`,
          classNameTitle,
          {
            'mb-8': isOpen,
          },
        )}
        type="button"
        onClick={toggle}
      >
        <h2 className="tw-font-subtitle4 tw-font-semibold">{label}</h2>

        <ButtonAnimation opened={isOpen} aria-hidden as="div">
          <ArrowIosDown size={24} ignoreColor className="fill-current" />
        </ButtonAnimation>
      </button>
      <Collapse defaultOpen={isDefaultOpen} open={isOpen}>
        {children}
      </Collapse>
    </div>
  );
};

export default HamburgerMenu;
